import { RemixBrowser } from '@remix-run/react'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { initPlausible } from './utils/plausible.client.ts'
import { syncTestingFlagFromUrl } from './utils/test-mode.client.ts'

// Plausible ignores localhost by default, so no env-gate is needed here —
// dev runs against localhost and produces no events.
initPlausible()

// Read `?testing=1` / `?testing=0` from the URL and persist to localStorage.
// Runs before React hydrates so the flag is available on first render.
syncTestingFlagFromUrl()

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

// Register service worker so Chromium browsers can offer install-to-home-screen.
// The SW itself is a pass-through and intentionally does not cache anything.
// Two guards:
//   - production-only: avoid registering in dev, where the SW survives across
//     `npm run dev` restarts and can interfere with HMR until manually
//     unregistered.
//   - top-frame-only: Chromium doesn't surface install banners from iframes,
//     so skip when running inside the embed-mode iframe.
if (
	ENV.MODE === 'production' &&
	'serviceWorker' in navigator &&
	window.self === window.top
) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js').catch(err => {
			console.warn('SW registration failed:', err)
		})
	})
}

startTransition(() => {
	hydrateRoot(document, <RemixBrowser />)
})
